export default __webpack_public_path__ + "static/media/faq-box.f4a553a3.png";